import {
  CALLING_AGENT_DOWNLOAD_PATH,
  DIALER_DOWNLOAD_PATH,
  FIELD_AGENT_DOWNLOAD_PATH
} from '@cp/src/layout/Routes';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import NaviIconWithText from '@cp/src/assets/icons/NaviIconWithText';

const Cosmos = () => {
  const navigate = useNavigate();

  const handleRedirection = () => {
    navigate(FIELD_AGENT_DOWNLOAD_PATH);
  };

  const handleRedirectionForFieldAgents = () => {
    navigate(CALLING_AGENT_DOWNLOAD_PATH);
  };

  const handleRedirectionForDialer = () => {
    navigate(DIALER_DOWNLOAD_PATH);
  };

  return (
    <div>
      <div className="p-4 flex justify-center shadow-lg">
        <NaviIconWithText />
      </div>
      <div className={'flex items-center justify-center p-4'}>
        <div className="isolate  w-96 p-4 rounded-xl bg-white/20 shadow-lg ring-1 ring-black/5 shadow-lg flex justify-around flex-col">
          <Typography variant="h1">Download cosmos app for :</Typography>

          <Button onClick={handleRedirection} className="my-3" variant="primary">
            Download for Field agent
          </Button>

          <Button onClick={handleRedirectionForFieldAgents} className="my-3" variant="primary">
            Download for Calling Agent
          </Button>
          <Button onClick={handleRedirectionForDialer} className="my-3" variant="primary">
            Download Dialer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Cosmos;
